module.exports = __webpack_public_path__ + "assets/img/process-6.7315f74d.png";